import { render, staticRenderFns } from "./RolesManagementDetail.vue?vue&type=template&id=6d7ca610&scoped=true"
import script from "./RolesManagementDetail.vue?vue&type=script&lang=js"
export * from "./RolesManagementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7ca610",
  null
  
)

export default component.exports